import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PopularCourseBenefitsService} from '../../../shared/services/popular-course-benefits.service';

interface BenefitsTableRow {
    aspect: string;
    details: string[];
}

import {UtilsService} from '../../../shared/services/utils.service';
import {environment} from '../../../../environments/environment';
@Component({
    selector: 'app-popular-course-benefits',
    templateUrl: './popular-course-benefits.component.html',
    styleUrls: ['./popular-course-benefits.component.scss']
})
export class PopularCourseBenefitsComponent implements OnInit {
    public popularCourseId: any;
    submitting: any = false;
    dataExists: any = false;
    // Superseded by the rich table editor below (table_html) — kept commented out for now
    // in case the structured Aspect/Details table needs to come back.
    // tableRows: BenefitsTableRow[] = [];
    editorBlocks: Array<{type: 'content' | 'table', value: string}> = [{type: 'content', value: ''}];
    tinymceApiKey = environment.tinymceApiKey;

    tableEditorInit = {
        menubar: false,
        branding: false,
        plugins: 'lists link autolink charmap media searchreplace visualblocks wordcount codesample table',
        toolbar: 'undo redo | bold italic underline | bullist numlist | link media charmap | ' +
            'table tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol | removeformat'
    };

    constructor(private activatedRoute: ActivatedRoute,
                private popularCourseBenefitsService: PopularCourseBenefitsService) {
    }

    ngOnInit(): void {
        this.popularCourseId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.popularCourseBenefitsService.detailByAdmin(this.popularCourseId).subscribe(data => {
            this.dataExists = !!(data && data['info']);

            const blocks = (data && data['info']) ? UtilsService.splitEditorBlocks(data['info']) : [];
            if (data && data['table_html']) {
                blocks.push({type: 'table', value: data['table_html']});
            }
            this.editorBlocks = blocks.length ? blocks : [{type: 'content', value: ''}];

            // this.tableRows = (data && data['table_data'] && data['table_data'].length) ? data['table_data'] : [];
            // if (this.tableRows.length === 0) {
            //     this.addRow();
            // }
        });
    }

    addEditorBlock(editor: 'content' | 'table') {
        this.editorBlocks.push({type: editor, value: ''});
    }

    removeEditorBlock(index: number) {
        this.editorBlocks.splice(index, 1);
    }

    // addRow() {
    //     this.tableRows.push({aspect: '', details: ['']});
    // }
    //
    // removeRow(index: number) {
    //     this.tableRows.splice(index, 1);
    // }
    //
    // addDetail(rowIndex: number) {
    //     this.tableRows[rowIndex].details.push('');
    // }
    //
    // removeDetail(rowIndex: number, detailIndex: number) {
    //     this.tableRows[rowIndex].details.splice(detailIndex, 1);
    // }

    submit() {
        const info = UtilsService.joinEditorBlocks(this.editorBlocks);

        const params = {
            'info': info ? UtilsService.encodeHtml(info) : '',
            'table_html': ''
            // 'table_data': cleanedRows — commented out along with the structured table UI above
        };
        this.submitting = true;
        if (this.dataExists) {
            this.popularCourseBenefitsService.updateByAdmin(this.popularCourseId, params).subscribe(data => {
                this.submitting = false;
            }, error => {
                this.submitting = false;
            });
        } else {
            this.popularCourseBenefitsService.createByAdmin(this.popularCourseId, params).subscribe(data => {
                this.submitting = false;
                this.dataExists = true;
            }, error => {
                this.submitting = false;
            });
        }
    }
}
